import React from 'react';
import ServiceDetailTemplate from '../Elements/ServiceDetailTemplate';

const bnrimg = require('../../images/sec1.jpg');
const productImg = require('../../images/Administracion_del_sistema.png');

const ServiceDetailAdmin = () => (
    <ServiceDetailTemplate
        moduleKey="administracion"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ServiceDetailAdmin;
